import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-151" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-152" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-153" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-[#F5C400] bg-[#0B1F4D] text-white font-bold text-[10px] sm:text-sm tracking-widest mb-4 sm:mb-6" data-id="element-154" data-mp="3d21ty23jwspu">
            ELECTRICAL TECHNOLOGY INSTRUCTOR <span className="text-[#FFD60A]" data-id="element-155" data-mp="3j897lcz58bpj">ATLAS</span>
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-[#0B1F4D] uppercase" data-id="element-156" data-mp="3o7c0y05rgtho">
            Solve <span className="text-[#1236C0]" data-id="element-157" data-mp="39a36uyp2pbm9">Months of Electrical Class Planning</span>{' '}
            <span className="bg-[#0B1F4D] text-[#FFD60A] px-2 box-decoration-clone" data-id="element-158" data-mp="3e7uxzqhw8tpe">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-159" data-mp="358hleoyh3p0g">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-160" data-mp="2vglm5aknhsun" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-161" data-mp="2ljz38rbvxbv9">
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-162" data-mp="n98cdkmjmzmb">
            The Complete{' '}
            <span className="font-semibold text-[#7A5C00]" data-id="element-163" data-mp="ddwwgyzefmcz">
              6-IN-1 Visual Electrical Systems &amp; Technical Training System for Electrical Instructors, Technical Schools &amp; Training Workshops.
            </span>
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164" data-mp="162lz52g3rzqu">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-165" data-mp="111y8wizp7mxo">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700/80 mb-3" data-id="element-166" data-mp="3lqm4435bldx1">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-167" data-mp="1xavxukzeea7s">
                <CheckCircle size={14} className="text-[#1236C0]" data-id="element-168" data-mp="21a4srt66ce4x" />
                <span className="font-medium" data-id="element-169" data-mp="269zhpr6e2tnc">{item}</span>
              </div>)}
          </div>

          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-170" data-mp="2b0fvxdi1ajar">
            <span className="font-semibold text-[#0B1F4D]" data-id="element-171" data-mp="2g0c3fmpxwsv2">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — everything organized to help you plan, explain, demonstrate and assess every
            electrical class, lab session and training workshop, from circuit theory and electrical safety to residential wiring, circuit protection, motors and controls, diagrams, testing and troubleshooting, PLCs and variable frequency drives, from beginner to advanced, with more clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#7A5C00] mb-5 sm:mb-7" data-id="element-172" data-mp="zlstdh7orj4c">
            FROM CIRCUIT THEORY &amp; LAB SAFETY TO WIRING, MOTORS, TROUBLESHOOTING, PLCs &amp; TEACHING METHODS
          </p>

          <p className="text-xs text-slate-500" data-id="element-173" data-mp="e9jwdqsj53qb">
            6 VISUAL VOLUMES · 300 TRAINING PAGES · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}